import { render, staticRenderFns } from "./menuIcon.vue?vue&type=template&id=215dc42c&scoped=true&"
import script from "./menuIcon.vue?vue&type=script&lang=js&"
export * from "./menuIcon.vue?vue&type=script&lang=js&"
import style0 from "./menuIcon.vue?vue&type=style&index=0&id=215dc42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215dc42c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VCard,VIcon})
